import styled from "styled-components";

const InfoBlock = styled.div`
  display: grid;
  gap: 16px;
`;

export default InfoBlock;
